import { Box, Typography } from "@mui/material";
import CommonNonAuthenticatedPageLayout from "../components/CommonNonAuthenticatedPageLayout";

export const ChildProtectionPolicy = () => {
  return (
    <CommonNonAuthenticatedPageLayout>
      <Box sx={{ mt: 1, width: "100%" }}>
        <Typography fontWeight={700} variant="h6">
          Policy Against Child Sexual Abuse and Exploitation (CSAE)
        </Typography>
        <Typography>
          Our app strictly prohibits any content that exploits or abuses children. This includes all content that
          depicts or promotes child sexual abuse or any form of child exploitation.
        </Typography>
        <Typography fontWeight={700} variant="h6">
          Enforcement
        </Typography>
        <Typography>
          - We use a combination of automated systems and human moderation to detect and remove such content.
        </Typography>
        <Typography>
          - We promptly remove and report any violative material to relevant authorities, including the National Center
          for Missing & Exploited Children (NCMEC).
        </Typography>
        <Typography fontWeight={700} variant="h6">
          Reporting
        </Typography>
        <Typography>
          Users can report inappropriate content or behavior within the app using the built-in reporting tools, or by
          contacting us at{" "}
          <a href="mailto:jsena@crwd.tech" type="email">
            jsena@crwd.tech
          </a>
        </Typography>
        <Typography fontWeight={700} variant="h6">
          Compliance
        </Typography>
        <Typography>
          We comply with all applicable local laws and regulations. We are committed to creating a safe environment for
          all users, especially minors.
        </Typography>
      </Box>
    </CommonNonAuthenticatedPageLayout>
  );
};

export default ChildProtectionPolicy;
